import { render, staticRenderFns } from "./EventsPrintDialog.html?vue&type=template&id=22e8a644&scoped=true&"
import script from "./EventsPrintDialog.ts?vue&type=script&lang=ts&"
export * from "./EventsPrintDialog.ts?vue&type=script&lang=ts&"
import style0 from "./EventsPrintDialog.scss?vue&type=style&index=0&id=22e8a644&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e8a644",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VBtn,VCardActions,VCardText,VContainer,VDialog,VIcon,VSelect})
